import mixpanel from "./mixpanel";
import { decodeToken } from "Components/SbSessionCheckerComponent/SbSessionChecker";
import { ANALYTICS_EVENTS } from "../../../constants/analyticsEvents.constants";

const envToken = process.env.REACT_APP_MIXPANEL_TOKEN;
const experimentToken = process.env.REACT_APP_MIXPANEL_EXPERIMENT_TOKEN;

const getInstance = (name) => {
  return mixpanel[name] || null;
};

export const MixpanelProvider = {
  organizationId: null,

  getOrganizationId () {
    if (this.organizationId) return this.organizationId;
    const token = localStorage.getItem("access_token");
    if (token) {
      const decoded = decodeToken(token);
      this.organizationId = decoded?.org_unique_id ?? null;
    }
    return this.organizationId;
  },

  setOrgUniqueId(id) {
    this.organizationId = id;
  },

  getProviders() {
    const providers = [];
    if (envToken) {
      const envInstance = getInstance(ANALYTICS_EVENTS.MIXPANEL.ENV_INSTANCE);
      if (envInstance) providers.push(envInstance);
    }

    if (experimentToken) {
      const expInstance = getInstance(ANALYTICS_EVENTS.MIXPANEL.EXPERIMENT_INSTANCE);
      if (expInstance) providers.push(expInstance);
    }

    return providers;
  },

  identify(userId, properties = {}) {
    this.getProviders().forEach(provider => {
      provider.identify(userId);
      if (Object.keys(properties).length) {
        provider.people.set({
          ...properties,
          envToken: envToken,
          organization_id: this.getOrganizationId()
        });
      }
    });
  },

  track(eventName, properties = {}) {
    const providers = this.getProviders();

    if (!providers.length) {
      console.warn("No Mixpanel providers available");
      return;
    }

    providers.forEach(provider => {
      provider.track(eventName, {
        ...properties,
        envToken: envToken,
        organization_id: this.getOrganizationId(),
      });
    });
  },

  reset() {
    this.getProviders().forEach(provider => {
      provider.reset();
    });
  },
};